import Vue from 'vue';
import VueWait from 'vue-wait';
import VModal from 'vue-js-modal';
import VTooltip from 'v-tooltip';
import VueCookies from 'vue-cookies';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import Customizer from '@/views/Customizer';

import { EventBus } from '@/eventBus';
import recipe from "@/plugins/recipe";
import endpoints from '@/plugins/endpoints';
import model3D from '@/plugins/model3D';
import personalization from '@/plugins/personalization';
import ugc from '@/plugins/ugc';
import dataLayer from '@/plugins/dataLayer';
import iframeCommunicator from '@/plugins/iframeCommunicator';
import store from '@/store';
import globalScope from '@/globalScope';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_DEVTOOLS_ENABLED;

Vue.use(VueWait);
Vue.use(VModal, { componentName: 'vue-modal' });
Vue.use(VTooltip, {
  defaultTemplate: '<div class="vue-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  popover: {
    defaultBaseClass: 'customs-tooltip customs-popover',
  },
});
Vue.use(VueCookies);

Vue.use(model3D);
Vue.use(recipe({ $store: store, $eventBus: EventBus }));
Vue.use(endpoints({ $store: store }));
Vue.use(personalization({ $store: store, $eventBus: EventBus, $recipe: Vue.prototype.$recipe, $model3D: Vue.prototype.$model3D }));
Vue.use(ugc({ $store: store, $recipe: Vue.prototype.$recipe }));
Vue.use(iframeCommunicator({ $eventBus: EventBus }));
Vue.use(Toast, {position: "top-center", draggable: false});

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$customizerDataLayer = dataLayer.customizer(store);
Vue.prototype.$ugcDataLayer = dataLayer.ugc(store);
Vue.prototype.$embroideryDataLayer = dataLayer.embroidery(store);
Vue.prototype.$ugcEntryPointDataLayer = dataLayer.ugcEntryPoint(store);
Vue.prototype.$patternMakerDatalayer = dataLayer.patternMaker(store);
Vue.prototype.$checkerboardDataLayer = dataLayer.checkerboard(store);
Vue.prototype.$customsMonetateQ = dataLayer.customsMonetateQ(store);
Vue.prototype.$customsGTM = dataLayer.customsGTM();

const vm = new Vue({
  store,
  wait: new VueWait({ useVuex: true }),
  render: h => h(Customizer)
}).$mount('#app');

globalScope('$Customizer', vm);